const headerScroll = () => {
	const header = document.querySelector('.header');
	if (!header) return;

	const toggleScrolledClass = () => {
		if (window.scrollY > 50) {
			header.classList.add('is-scrolled');
		} else {
			header.classList.remove('is-scrolled');
		}
	};

	window.addEventListener('scroll', toggleScrolledClass);
	toggleScrolledClass();
};

export default headerScroll;